import { Box, useMediaQuery, useTheme } from "@mui/material";
import { useLocation } from "react-router-dom";
import {
  getAppLayoutBackgroundColor,
  useSidebarDarkMode,
} from "../useAppLayoutAppearance";
import { APP_SHELL } from "./sidebar/MenuContent";

function MainContent({ children }) {
  const theme = useTheme();
  const location = useLocation();
  const hasMobileAppBar = useMediaQuery(theme.breakpoints.down("md"));
  const sidebarDark = useSidebarDarkMode();
  const backgroundColor = getAppLayoutBackgroundColor(theme, sidebarDark);
  const isCanvasRoute = location.pathname === "/canais/chatbot";

  return (
    <Box
      className="MainContent"
      component="main"
      sx={{
        backgroundColor,
        display: "flex",
        flex: 1,
        flexDirection: "column",
        height: {
          xs: "100vh",
          md: `calc(100vh - ${APP_SHELL.topbarHeight}px)`,
        },
        minHeight: {
          xs: "100vh",
          md: `calc(100vh - ${APP_SHELL.topbarHeight}px)`,
        },
        minWidth: 0,
        overflowX: "hidden",
        overflowY: isCanvasRoute ? "hidden" : "auto",
        scrollbarGutter: isCanvasRoute ? "auto" : "stable",
        scrollbarColor: `${theme.palette.border.strong} ${backgroundColor}`,
        scrollbarWidth: "thin",
        width: "100%",
        ...(hasMobileAppBar && {
          maxWidth: "100vw",
          paddingTop: `${APP_SHELL.mobileHeaderHeight}px`,
        }),
      }}
    >
      {children}
    </Box>
  );
}

export default MainContent;
